import { create } from 'zustand'
import { ApprovalStatus } from '../database/enums/ApprovalStatus.enum'
import { MedicalReimbursement } from '../database/tables'

interface IAdminMedicalReimbursementApprovalPopupStore {
  open: boolean
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
  approvalStatus: ApprovalStatus | null
  data: MedicalReimbursement | null
}

const adminMedicalReimbursementApprovalPopupStore = create<IAdminMedicalReimbursementApprovalPopupStore>()(() => ({
  open: false,
  isLoading: false,
  isError: false,
  isSuccess: false,
  approvalStatus: null,
  data: null,
}))

export default adminMedicalReimbursementApprovalPopupStore
